import { NumberFormatter } from "client/Hooks";
import { PropsWithChildren, ReactElement } from "react";
import { useHubStatisticsFormatter } from "./useHubStatisticsFormatter";
import { ReactionsCountButton } from "../Reactions/ReactionsCountButton/ReactionsCountButton";
import { IconAndText } from "client/Components";
import { ReactionCounterModel } from "client/Api/Hub/common";
import styles from "./HubDetailsContentFooter.module.less";
import classNames from "classnames";

type HubDetailsLayoutStatistic = {
	onClick?(): void;
	tooltip?: string;
};

export type HubDetailsContentFooterProps = {
	stats?: {
		reactions?: HubDetailsLayoutStatistic & { value: readonly ReactionCounterModel[];};
		views?: HubDetailsLayoutStatistic & { value: number; };
	};
	rightSide?: ReactElement;
	hasNoMargin?: boolean;
};

export const HubDetailsContentFooter = (
	props: PropsWithChildren<HubDetailsContentFooterProps>
): ReactElement => {
	const {
		stats,
		rightSide,
		children,
		hasNoMargin = false
	} = props;

	const statisticsFormatter: NumberFormatter = useHubStatisticsFormatter();

	return (
		<footer
			className={
				classNames(
					styles.root,
					{
						[styles.root_noMargin]: hasNoMargin
					}
				)
			}
		>
			<div className={styles.statisticsContainer}>
				{stats && (
					<div className={styles.statistics}>
						{stats.reactions && (
							<span
								className={styles.statistic}
							>
								<ReactionsCountButton
									trackingId="reactions-count-button"
									counters={stats.reactions.value}
									onClick={stats.reactions.onClick}
								/>
							</span>
						)}
						{stats.views && (
							<span
								className={styles.statistic}
							>
								<IconAndText
									trackingId="views-count"
									text={statisticsFormatter(stats.views.value)}
									tooltip={stats.views.tooltip}
									onClick={stats.views.onClick}
								>
									<IconAndText.Icon
										value="eye"
									/>
								</IconAndText>
							</span>
						)}
					</div>
				)}

				{rightSide && (
					<div className={styles.statisticsRightSide}>
						{rightSide}
					</div>
				)}
			</div>

			<hr className={styles.lineSeparator} />
			<div>
				{children}
			</div>
		</footer>
	);
};
HubDetailsContentFooter.displayName = "HubDetailsContentFooter";